// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class PfixQuoteBarGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.QUOTE_BAR_GROUP, null, pfixFieldSet);
    }
    getTime() {
        return this.GetValue(FieldsFactory.FIELD_TIMESTAMP);
    }
    getBarType() {
        return this.GetValue(FieldsFactory.FIELD_BARS_TYPE);
    }
    getOpen() {
        return this.GetValue(FieldsFactory.FIELD_OPEN);
    }
    getHigh() {
        return this.GetValue(FieldsFactory.FIELD_HIGH);
    }
    getLow() {
        return this.GetValue(FieldsFactory.FIELD_LOW);
    }
    getClose() {
        return this.GetValue(FieldsFactory.FIELD_CLOSE_PRICE);
    }
    getMainClose() {
        return this.GetValue(FieldsFactory.FIELD_MAIN_CLOSE_PRICE);
    }
    getAsk() {
        return this.GetValue(FieldsFactory.FIELD_ASK);
    }
    getAskVolume() {
        const fieldAskVolume = this.GetValue(FieldsFactory.FIELD_ASK_VOLUME);
        if (fieldAskVolume !== null) {
            return fieldAskVolume;
        }
        else {
            const fieldAskSize = this.GetValue(FieldsFactory.FIELD_ASK_SIZE);
            if (fieldAskSize !== null) {
                return fieldAskSize;
            }
        }
        return null;
    }
    getBid() {
        return this.GetValue(FieldsFactory.FIELD_BID);
    }
    getBidVolume() {
        const fieldBidVolume = this.GetValue(FieldsFactory.FIELD_BID_VOLUME);
        if (fieldBidVolume !== null) {
            return fieldBidVolume;
        }
        else {
            const fieldBidSize = this.GetValue(FieldsFactory.FIELD_BID_SIZE);
            if (fieldBidSize !== null) {
                return fieldBidSize;
            }
        }
        return null;
    }
    getPrice() {
        return this.GetValue(FieldsFactory.FIELD_PRICE);
    }
    getVolume() {
        const fieldVolume = this.GetValue(FieldsFactory.FIELD_VOLUME);
        if (fieldVolume !== null) {
            return fieldVolume;
        }
        else {
            const fieldSize = this.GetValue(FieldsFactory.FIELD_SIZE);
            if (fieldSize !== null) {
                return fieldSize;
            }
        }
        return null;
    }
    getSettlementPrice() {
        return this.GetValue(FieldsFactory.FIELD_SETTLEMENT_PRICE);
    }
    GetLastQuoteID() {
        return this.GetValue(FieldsFactory.FIELD_SUB_ID);
    }
    GetLastQuoteIdDate() {
        return this.GetValue(FieldsFactory.FIELD_SUB_ID_DATE);
    }
    getIsOpen() {
        return this.GetValue(FieldsFactory.FIELD_IS_OPEN);
    }
}
